import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppService } from './../../../../shared/services/geral/app.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FilterUtils } from "primeng/utils";
import { environment } from './../../../../../../../src/environments/environment';
import { LazyLoadEvent } from 'primeng/api';

@Component({
  selector: 'app-monitor-processos',
  templateUrl: './monitor-processos.component.html',
  styleUrls: ['./monitor-processos.component.css']
})

export class MonitorProcessosComponent implements OnInit, OnDestroy {

  constructor(public svc: AppService, private router: Router, private tl: TranslateService) {
  }

  public dataFiltro: Date;

  public total_abertos: number = 0;
  public busca: any = {
    numero_pagina: 1,
    total_por_pagina: 5,
    termo_busca: "",
    quantidade: 5
  };
  public ulHora: string = "";
  public progresso: number;
  public progressoLabel: number;
  public progressoTimeout: any;
  public slide_cor: string = "";
  public checkTipoFiltroPerc: boolean = false;
  public cols: any[];
  public processos: any[];
  public processo_selecionado: any;
  public eventos_processo_selecionado: any[] = [];
  public email_selecionado: any[] = [];
  public traducao: any = {
    geral: "",
    tabela: ""
  }
  public cores: string[] = ["rgba(66, 165, 245, 0.35)", "rgba(124, 179, 66, 0.35)", "rgba(255, 93, 81, 0.35)"];
  public cores2: string[] = ["rgba(66, 165, 245, 0.65)", "rgba(124, 179, 66, 0.65)", "rgba(255, 93, 81, 0.65)"];
  public bordas: string[] = ["rgb(66, 165, 245)", "rgb(124, 179, 66)", "rgb(255, 93, 81)"];
  public dataGrafico: any = {};
  public optionsGrafico = {
    line: {
      borderColor: 'rgb(255,255,255)'
    },
    title: {
      display: false
    },
    legend: {
      display: false
    },
    scales: {
      xAxes: [{
        stacked: true,
        ticks: {
          fontColor: environment.tema_css == "black" ? '#9eacb5' : '#a7abad'
        },
        gridLines: {
          display: false,
        }
      }],
      yAxes: [{
        stacked: true,
        ticks: {
          fontColor: environment.tema_css == "black" ? '#9eacb5' : '#a7abad',
          maxTicksLimit: 6
        },
        gridLines: {
          color: environment.tema_css == "black" ? '#2c343a' : '#d6cfce'
        }
      }]
    }
  };

  public spinChart = false;
  public spinTable = false;
  public spinHistorico = false;
  public spinFiltro = false;
  public flC1 = false;
  public flC2 = false;
  public flC3 = false;
  public chart1: any = {
    porcentagem: 0,
    titulo: "",
    operador: "",
    dias: 0,
    legenda: ""
  };
  public chart2: any = {
    porcentagem: 0,
    titulo: "",
    operador: "",
    dias: 0,
    legenda: ""
  };
  public chart3: any = {
    porcentagem: 0,
    titulo: "",
    operador: "",
    dias: 0,
    legenda: ""
  };
  public options: any = {
    trackColor: environment.tema_css == "black" ? '#777777' : '#e2e2e2',
    scaleColor: false,
    scaleLength: 5,
    lineCap: 'round',
    lineWidth: 3,
    size: 50,
    rotate: 0,
    animate: {
      duration: 1000,
      enabled: true
    }
  };
  public filtroServico = 0;

  public sbAbrirModal(event: Event): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public sbAbrirEvento(event: Event, evento: string, data: any): void {
    try {
      this.processo_selecionado = data;
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public sbAbrirModalAndamento(event: Event, data) : void{
    try {
      this.spinHistorico = true;
      var id = $(event.target).attr("data-modal");
      
     this.svc.HistoricoPoderClientePesquisar(data);
     this.svc.HistoricoPoderCliente().subscribe((resp) => {
        if (resp == false) this.spinHistorico = false;
        else if (resp != null) {
          this.spinHistorico = false;
          this.eventos_processo_selecionado = resp.eventos_processo;
        }
      });
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public sbAbrirModalEmail(event: Event, data): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.email_selecionado = data;
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public sbReenviarEmail(data) {
    try {
      this.spinTable = true;
      this.svc.ReenviarEmail(data.id_poder_cliente);
      this.svc.EmailReenviado().subscribe((resp) => {
        if (resp == false) this.spinTable = false;
        else if (resp != null) {
          // this.carregarProcessos();
          this.spinTable = false;
          this.svc.sbExibirAlerta("success", this.tl.instant("geral.mensagens.enviado"), "E-mail Reenviado com Sucesso!");
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public eventoFeitoConferido(evento: string): void {
    try {
      this.svc.EventoFeitoConferidoEnviar({
        id_poder_cliente: this.processo_selecionado.id_poder_cliente,
        tipo_solicitacao: evento
      });
      this.svc.EventoFeitoConferido().subscribe((resp) => {
        if (resp != null) {
          this.svc.sbFecharModal("modalCancelar");
          this.svc.sbFecharModal("modalConfirma");
          this.svc.sbExibirAlerta("success", this.tl.instant("geral.mensagens.enviado"), this.tl.instant("feito_conferido_tabela.mensagens.acao_enviada"));
          // this.carregarProcessos();
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public checkAll(event) {
    this.processos.forEach((item, index) => {
      this.processos[index].fl = event.target.checked;
    });
  }

  public sbFiltrarPercentual(dt): void {
    if (this.progresso) {
      if (this.progressoTimeout) {
        clearTimeout(this.progressoTimeout);
      }

      if (this.progresso == 101) {
        this.slide_cor = "slider-verde";
      } else if (this.progresso < 101 && this.progresso > 66) {
        this.slide_cor = "slider-azul";
      } else if (this.progresso <= 66 && this.progresso > 33) {
        this.slide_cor = "slider-amarela";
      } else if (this.progresso <= 33 && this.progresso > 0) {
        this.slide_cor = "slider-vermelha";
      } else {
        this.slide_cor = "";
      }

      this.progressoLabel = this.progresso - 1;

      this.progressoTimeout = setTimeout(() => {
        if (this.checkTipoFiltroPerc)
          dt.filter(this.progresso - 1, 'percentual_andamento', 'equals');
        else
          dt.filter(this.progresso, 'percentual_andamento', 'lt');
      }, 250);
    }
  }

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public sbCarregarIdioma() {
    this.cols = [
      { type: 'doc_vencido', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_processo', size: '4%', text_align: 'text-right' },
      { type: 'icon-email', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'fl', size: '4%', text_align: 'text-center' },
      { type: 'text-duplo', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("monitor_tabela.cliente"), field: 'nome_cliente', size: '26%', coluna_aux: 'documento_cliente', text_align: 'text-left' },
      { type: 'hide', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'documento_cliente', size: '0%', text_align: 'text-left' },
      { type: 'text-duplo', sort: true, filter: true, filter_type: 'multi-select', header: this.tl.instant("monitor_tabela.processo"), field: 'nome_processo', size: '18%', coluna_aux: 'numero_contrato', text_align: 'text-left' },
      { type: 'hide', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'numero_contrato', size: '0%', text_align: 'text-left' },
      { type: 'barra-progresso', sort: true, filter: true, filter_type: 'slide', header: this.tl.instant("monitor_tabela.percentual"), field: 'percentual_andamento', size: '12%', text_align: 'text-left' },
      { type: 'data', sort: true, filter: true, filter_type: 'data', header: this.tl.instant("monitor_tabela.data"), field: 'data_ult_evento', size: '13%', text_align: 'text-left' },
      { type: 'badge', sort: true, filter: false, filter_type: 'multi-select', header: this.tl.instant("monitor_tabela.email"), field: 'qtd_email', size: '9%', text_align: 'text-center' },
      { type: 'icon-cancelar', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_processo', size: '4%', text_align: 'text-left' },
      { type: 'icon-aprovar', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_processo', size: '4%', text_align: 'text-left' },
      { type: 'icon-conferir', sort: false, filter: false, filter_type: 'multi-select', header: '', field: 'id_processo', size: '4%', text_align: 'text-left' }
    ];
  }

  public carregarProcessosLazy(event: LazyLoadEvent) {
    var termoBusca = event.globalFilter;
    if (termoBusca == null) {
      termoBusca = "";
    }

    let currentPage: number;
    currentPage = event.first / event.rows + 1;
    this.busca.numero_pagina = currentPage;
    this.busca.termo_busca = termoBusca;
    this.carregarProcessosPaginado();
    console.log('currentPage = ' + currentPage);
    console.log(this.busca);

  }

  public carregarProcessos() {
    try {
      this.spinTable = true;
      this.svc.MonitorProcessosPesquisar();
      this.svc.MonitorProcessos().subscribe((resp) => {
        if (resp == false) this.spinTable = false;
        else if (resp != null) {          
          this.spinTable = false;
          for (let i = 0; i < resp.processos.length; i++) {
            resp.processos[i].fl = false;
          }
          this.processos = resp.processos;
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public carregarProcessosPaginado() {
    try {
      this.spinTable = true;
      this.svc.MonitorProcessosPesquisarPaginado(this.busca);
      this.svc.MonitorProcessosPaginado().subscribe((resp) => {
        if (resp == false) this.spinTable = false;
        else if (resp != null) {
          this.busca.total_processos = resp.total_processos;
          this.spinTable = false;
          for (let i = 0; i < resp.processos.length; i++) {
            resp.processos[i].fl = false;
          }
          this.processos = resp.processos;
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public carregarFiltros() {
    try {
      this.spinFiltro = true;
      this.svc.NiveisServicoListaPesquisar();
      this.svc.NiveisServicoListaEncontrado().subscribe((resp) => {
        if (resp == false) this.spinFiltro = false;
        else if (resp != null) {
          this.total_abertos = resp.total;
          this.spinFiltro = false;
          this.flC1 = false;
          this.flC2 = false;
          this.flC3 = false;
          if (resp.lista_servicos.length >= 1) { this.chart1 = resp.lista_servicos[0]; this.flC1 = true };
          if (resp.lista_servicos.length >= 2) { this.chart2 = resp.lista_servicos[1]; this.flC2 = true };
          if (resp.lista_servicos.length >= 3) { this.chart3 = resp.lista_servicos[2]; this.flC3 = true };
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public carregarGrafico() {
    try {
      this.spinChart = true;
      this.svc.GraficoProcessosPesquisar();
      this.svc.CarregarGrafico().subscribe((resp: any) => {
        if (resp == false) this.spinChart = false;
        else if (resp != null) {
          this.spinChart = false;
          resp.data.datasets.forEach((item, index) => {
            if (item.type == 'line') {
              item.backgroundColor = "rgba(243, 206, 23, 0.1)";
              item.borderColor = "rgb(243, 206, 23)";
              item.borderWidth = '1.5'
            } else {
              item.backgroundColor = environment.tema_css == "black" ? this.cores[index] : this.cores2[index];
              item.borderColor = this.bordas[index];
              item.borderWidth = '1';
              item.maxBarThickness = 70;
            }
          });
          this.dataGrafico = resp.data;
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public atualizarTela() {
    try {
      this.carregarProcessos();
      this.carregarGrafico();
      this.ulHora = new Date().toLocaleTimeString();
      this.filtroServico = 0;
      this.carregarFiltros();
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  ngOnInit() {
    try {

      this.ulHora = new Date().toLocaleTimeString();
      this.carregarProcessos();
      this.carregarGrafico();
      this.carregarFiltros();

      //É chamado sempre que o Idioma for Mudado
      this.svc.sbGetTraducaoAuto("monitor_tabela").subscribe((resp) => {
        this.sbCarregarIdioma();
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }


  ngOnDestroy(): void {
    this.dataFiltro = new Date;
  }
}

